import { Modal } from '@pa/ui'
import { useId } from 'react'

export interface ConfirmDialogProps {
  title: string
  body: string
  action: string
  /** Remove is destructive (red button). */
  danger?: boolean
  pending?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/** The confirm step of C-13's Reset password, Change role and Remove (UserFlows C-13 "Confirm"). */
export function ConfirmDialog({ title, body, action, danger, pending, onConfirm, onCancel }: ConfirmDialogProps) {
  const id = useId()
  return (
    <Modal onClose={onCancel} labelledBy={`${id}-title`} describedBy={`${id}-body`}>
      <div className="modal-head">
        <div>
          <h2 id={`${id}-title`}>{title}</h2>
        </div>
      </div>
      <div className="modal-body">
        <p id={`${id}-body`}>{body}</p>
      </div>
      <div className="modal-foot">
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
          disabled={pending}
          onClick={onConfirm}
        >
          {action}
        </button>
      </div>
    </Modal>
  )
}
